import { Link, tokens, Typography } from '@sapphire-react/core';
import { useTranslation } from 'react-i18next';

const paragraphs = ['moreInformation.items.nextStepsProperty.paragraph1'];
const externalLink = 'moreInformation.items.nextStepsProperty.link';

const CreateSectionContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography.Body>{t(paragraphs[0])}</Typography.Body>
      <Link marginTop={tokens.size.spacingMd}>
        <a
          target={'_blank'}
          rel={'noreferrer'}
          href={
            'https://danskebank.se/privat/produkter/bolan/infor-bostadskopet'
          }
        >
          {t(externalLink)}
        </a>
      </Link>
    </>
  );
};

export const nextStepsBuyingPropertyData = {
  key: 'next-steps-buying-property-data',
  text: 'moreInformation.items.nextStepsProperty.title',
  content: <CreateSectionContent />,
};
